import { ActivatedRoute } from '@angular/router'
import { Component, OnInit } from '@angular/core'
import { AuthService } from '@core/services'
import { AnalyticsService } from '@shared/services/analytics.service'
import { getAppName } from '@core/utils/application.utils'

@Component({
  selector: 'app-callback',
  templateUrl: './callback.component.html',
  styleUrls: ['./callback.component.scss'],
  standalone: false,
})
export class CallbackComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private authService: AuthService,
    public analyticsServices: AnalyticsService,
  ) {}

  ngOnInit() {
    const { application } = this.route.snapshot.params
    const appName = getAppName(application)
    const eventName = appName.replace(/ /g, '')
    const category = `access_${eventName}`
    const action = `navigation_to_${eventName}`
    const label = `${eventName} access`

    this.analyticsServices.trackEvent(category, action, label)
    this.authService.applicationName = appName
    this.authService.endSigninMainWindow()
  }
}
